export const CREATE_EXPLORE_REQUEST = "CREATE_EXPLORE_REQUEST";
export const CREATE_EXPLORE_SUCCESS = "CREATE_EXPLORE_SUCCESS";
export const CREATE_EXPLORE_FAILED = "CREATE_EXPLORE_FAILED";

export const GET_EXPLORE_REQUEST = "GET_EXPLORE_REQUEST";
export const GET_EXPLORE_SUCCESS = "GET_EXPLORE_SUCCESS";
export const GET_EXPLORE_FAILED = "GET_EXPLORE_FAILED";

export const UPDATE_EXPLORE_REQUEST = "UPDATE_EXPLORE_REQUEST";
export const UPDATE_EXPLORE_SUCCESS = "UPDATE_EXPLORE_SUCCESS";
export const UPDATE_EXPLORE_FAILED = "UPDATE_EXPLORE_FAILED";

export const PUBLISHED_EXPLORE_STATUS_REQUEST =
  "PUBLISHED_EXPLORE_STATUS_REQUEST";
export const PUBLISHED_EXPLORE_STATUS_SUCCESS =
  "PUBLISHED_EXPLORE_STATUS_SUCCESS";
export const PUBLISHED_EXPLORE_STATUS_FAILED =
  "PUBLISHED_EXPLORE_STATUS_FAILED";

export const DRAFT_EXPLORE_ACTIVE_STATUS_REQUEST =
  "DRAFT_EXPLORE_ACTIVE_STATUS_REQUEST";
export const DRAFT_EXPLORE_ACTIVE_STATUS_SUCCESS =
  "DRAFT_EXPLORE_ACTIVE_STATUS_SUCCESS";
export const DRAFT_EXPLORE_ACTIVE_STATUS_FAILED =
  "DRAFT_EXPLORE_ACTIVE_STATUS_FAILED";

export const SEARCH_EXPLORE_REQUEST = "SEARCH_EXPLORE_REQUEST";
export const SEARCH_EXPLORE_SUCCESS = "SEARCH_EXPLORE_SUCCESS";
export const SEARCH_EXPLORE_FAILED = "SEARCH_EXPLORE_FAILED";

export const GET_EXPLORE_CATEGORY_REQUEST = "GET_EXPLORE_CATEGORY_REQUEST";
export const GET_EXPLORE_CATEGORY_SUCCESS = "GET_EXPLORE_CATEGORY_SUCCESS";
export const GET_EXPLORE_CATEGORY_FAILED = "GET_EXPLORE_CATEGORY_FAILED";

export const PREVIEW_EXPLORE_SUCCESS = "PREVIEW_EXPLORE_SUCCESS";

export const CREATE_EXPLORE_CATEGORY_REQUEST =
  "CREATE_EXPLORE_CATEGORY_REQUEST";
export const CREATE_EXPLORE_CATEGORY_SUCCESS =
  "CREATE_EXPLORE_CATEGORY_SUCCESS";
export const CREATE_EXPLORE_CATEGORY_FAILED = "CREATE_EXPLORE_CATEGORY_FAILED";

export const UPDATE_EXPLORE_CATEGORY_REQUEST =
  "UPDATE_EXPLORE_CATEGORY_REQUEST";
export const UPDATE_EXPLORE_CATEGORY_SUCCESS =
  "UPDATE_EXPLORE_CATEGORY_SUCCESS";
export const UPDATE_EXPLORE_CATEGORY_FAILED = "UPDATE_EXPLORE_CATEGORY_FAILED";

export const ACTIVE_EXPLORE_CATEGORY_REQUEST =
  "ACTIVE_EXPLORE_CATEGORY_REQUEST";
export const ACTIVE_EXPLORE_CATEGORY_SUCCESS =
  "ACTIVE_EXPLORE_CATEGORY_SUCCESS";
export const ACTIVE_EXPLORE_CATEGORY_FAILED = "ACTIVE_EXPLORE_CATEGORY_FAILED";

export const CLEAR_EXPLORE_SUCCESS = "CLEAR_EXPLORE_SUCCESS";

export const REMOVE_EXPLORE_REQUEST = "REMOVE_EXPLORE_REQUEST";
export const REMOVE_EXPLORE_SUCCESS = "REMOVE_EXPLORE_SUCCESS";
export const REMOVE_EXPLORE_FAILED = "REMOVE_EXPLORE_FAILED";

export const REMOVE_CATEGORY_REQUEST = "REMOVE_CATEGORY_REQUEST";
export const REMOVE_CATEGORY_SUCCESS = "REMOVE_CATEGORY_SUCCESS";
export const REMOVE_CATEGORY_FAILED = "REMOVE_CATEGORY_FAILED";

export const REORDER_CONTENT_REQUEST = "REORDER_CONTENT_REQUEST";
export const REORDER_CONTENT_SUCCESS = "REORDER_CONTENT_SUCCESS";
export const REORDER_CONTENT_FAILED = "REORDER_CONTENT_FAILED";

export const COPY_CONTENT_REQUEST = "COPY_CONTENT_REQUEST";
export const COPY_CONTENT_SUCCESS = "COPY_CONTENT_SUCCESS";
export const COPY_CONTENT_FAILED = "COPY_CONTENT_FAILED";

export const CLEAR_EXPLORE_DATA = "CLEAR_EXPLORE_DATA";

export const previewExploreDataAction = (data) => {
  return { type: PREVIEW_EXPLORE_SUCCESS, payload: data };
};

export const createExploreDataAction = (data) => {
  return { type: CREATE_EXPLORE_REQUEST, payload: data };
};

export const getExploreDetailAction = (data) => {
  return { type: GET_EXPLORE_REQUEST, payload: data };
};

export const updateExploreDetailAction = (data) => {
  return { type: UPDATE_EXPLORE_REQUEST, payload: data };
};

export const publishedExploreStatus = (data) => {
  return { type: PUBLISHED_EXPLORE_STATUS_REQUEST, payload: data };
};
export const searchExplore = (data) => {
  return { type: SEARCH_EXPLORE_REQUEST, payload: data };
};

export const getExploreCategory = (data) => {
  return { type: GET_EXPLORE_CATEGORY_REQUEST, payload: data };
};

export const createExploreCategory = (data) => {
  return { type: CREATE_EXPLORE_CATEGORY_REQUEST, payload: data };
};

export const updateExploreCategory = (data) => {
  return { type: UPDATE_EXPLORE_CATEGORY_REQUEST, payload: data };
};

export const draftExploreActiveStatus = (data) => {
  return { type: DRAFT_EXPLORE_ACTIVE_STATUS_REQUEST, payload: data };
};

export const activeExploreCategory = (data) => {
  return { type: ACTIVE_EXPLORE_CATEGORY_REQUEST, payload: data };
};
export const RemoveExplore = (data) => {
  return { type: REMOVE_EXPLORE_REQUEST, payload: data };
};
export const RemoveCategory = (data) => {
  return { type: REMOVE_CATEGORY_REQUEST, payload: data };
};
export const ReOrderContent = (data) => {
  return { type: REORDER_CONTENT_REQUEST, payload: data };
};
export const CopyContent = (data) => {
  return { type: COPY_CONTENT_REQUEST, payload: data };
};
